import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { SplitComponent } from '../../split/components/split/split.component';
import { AgreementAnnexComponent } from './agreement-annex.component';
import { BasicDataStepComponent } from './basic-data-step/basic-data-step.component';
import { ChangedDataStepComponent } from './changed-data-step/changed-data-step.component';
import { SummaryStepComponent } from './summary-step/summary-step.component';
import { AnnexSummaryComponent } from './annex-summary/annex-summary.component';
import { AgreementDetailsTabComponent } from './agreement-details-tab/agreement-details-tab.component';
import { AgreementAnnexSidePanelComponent } from './agreement-annex-side-panel/agreement-annex-side-panel.component';
import { AnnexSignatureComponent } from './annex-signature/annex-signature.component';
import { SignatureApprovalListComponent } from './annex-signature/signature-approval-list/signature-approval-list.component';
import { SignatureMethodModalComponent } from './annex-signature/signature-method-modal/signature-method-modal.component';
import { SuccessfullySignedAnnexComponent } from './annex-signature/successfully-signed-annex/successfully-signed-annex.component';
import { SuccessfullySentAnnexToApprovalComponent } from './successfully-sent-annex-to-approval/successfully-sent-annex-to-approval.component';
import { AnnexApprovalProgressComponent } from './annex-signature/annex-approval-progress/annex-approval-progress.component';
import { PdfViewerModule } from "ng2-pdf-viewer";
import { ConflictedAnnexDialogComponent } from './conflicted-annex-dialog/conflicted-annex-dialog-component';
import { SuccessfullyCreatedAnnexComponent } from './successfully-created-annex/successfully-created-annex.component';
import { WageValuePipe } from "../../shared/pipes/wage-value.pipe";

@NgModule({
  declarations: [
    AgreementAnnexComponent,
    BasicDataStepComponent,
    ChangedDataStepComponent,
    SummaryStepComponent,
    AnnexSummaryComponent,
    AgreementDetailsTabComponent,
    AgreementAnnexSidePanelComponent,
    AnnexSignatureComponent,
    SignatureApprovalListComponent,
    SignatureMethodModalComponent,
    SuccessfullySignedAnnexComponent,
    SuccessfullySentAnnexToApprovalComponent,
    ConflictedAnnexDialogComponent,
    SuccessfullyCreatedAnnexComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    SplitComponent,
    PdfViewerModule,
    AnnexApprovalProgressComponent,
    WageValuePipe
],
  exports: [
    AgreementAnnexComponent,
    AnnexSummaryComponent,
    SummaryStepComponent,
  ]
})
export class AgreementAnnexModule { }
